module.exports = __webpack_public_path__ + "img/oscleton-settings-connection-screenshot.e6f3440a.png";